export function formatUSD(value: number, decimalPositions: number = 2): string {
  const str = value.toFixed(decimalPositions);
  if (/[.]/.test(str)) {
    return str.replace(/\d(?=(\d{3})+\.)/g, '$&,');
  } else {
    return str.replace(/\d(?=(\d{3})+$)/g, '$&,');
  }
}
